const DesignRepository = require('./../../../bundles/design/repository/DesignRepository');

if (window.CKEDITOR) {
	CKEDITOR.plugins.add('colorspanel', {
		requires: 'panelbutton,floatpanel',
		lang: 'fr,en',
		icons: 'bgcolor,textcolor',
		hidpi: true,
		init: function(editor) {
			let {config} = editor;
			let lang = editor.lang.colorspanel;

			const addButton = function(name, type, title, order, options) {
				let style = new CKEDITOR.style(config['colorspanel_' + type + 'Style']);
				let colorBoxId = CKEDITOR.tools.getNextId() + '_colorBox';
				let panelBlock;

				options = options || {};

				editor.ui.add(name, CKEDITOR.UI_PANELBUTTON, {
					label: title,
					title: title,
					modes: {wysiwyg: 1},
					editorFocus: 0,
					toolbar: 'colors,' + order,
					allowedContent: style,
					requiredContent: style,
					contentTransformations: options.contentTransformations,

					panel: {
						css: CKEDITOR.skin.getPath('editor'),
						attributes: {'role': 'listbox', 'aria-label': lang.panelTitle},
					},

					onBlock: function(panel, block) {
						panelBlock = block;

						block.autoSize = true;
						block.element.addClass('cke_colorblock');
						block.element.setHtml(renderColors(panel, type, colorBoxId));
						block.element.getDocument().getBody().setStyle('overflow', 'hidden');

						CKEDITOR.ui.fire('ready', this);

						let keys = block.keys;
						let rtl = editor.lang.dir == 'rtl';

						keys[rtl ? 37 : 39] = 'next';
						keys[40] = 'next';
						keys[9] = 'next';
						keys[rtl ? 39 : 37] = 'prev';
						keys[38] = 'prev';
						keys[CKEDITOR.SHIFT + 9] = 'prev';
						keys[32] = 'click';
					},

					refresh: function() {
						if (!editor.activeFilter.check(style)) {
							this.setState(CKEDITOR.TRISTATE_DISABLED);
						}
					},

					onOpen: function() {
						let selection = editor.getSelection();
						let	block = selection && selection.getStartElement();
						let	path = editor.elementPath(block);
						let	automaticColor;

						if (!path) {
							return;
						}

						block = path.block || path.blockLimit || editor.document.getBody();

						do {
							automaticColor = block && block.getComputedStyle(type == 'back' ? 'background-color' : 'color') || 'transparent';
						}
						while (type == 'back' && automaticColor == 'transparent' && block && (block = block.getParent()));

						if (!automaticColor || automaticColor == 'transparent') {
							automaticColor = '#ffffff';
						}

						let range = selection && selection.getRanges()[0];

						if (range) {
							let walker = new CKEDITOR.dom.walker(range);
							let	element = range.collapsed ? range.startContainer : walker.next();
							let	finalColor = '';
							let	currentColor;

							while (element) {
								if (element.type === CKEDITOR.NODE_TEXT) {
									element = element.getParent();
								}

								currentColor = normalizeColor(element.getComputedStyle(type == 'back' ? 'background-color' : 'color' ));
								finalColor = finalColor || currentColor;

								if (finalColor !== currentColor) {
									finalColor = '';
									break;
								}

								element = walker.next();
							}

							selectColor(panelBlock, finalColor);
						}

						return automaticColor;
					},
				});
			};

			if (!CKEDITOR.env.hc) {
				addButton('TextColor', 'fore', lang.textColorTitle, 10);
			}

			const renderColors = function(panel, type, colorBoxId) {
                let output = [];
                let colors = DesignRepository.getStaticAllColors().map((color) => {
                    return {
                        id: `text-${color.id}`,
                        color: color.color,
                    };
                });
				let	colorsPerRow = config.colorspanel_colorsPerRow || 6;
				let	moreColorsEnabled = editor.plugins.colordialog && config.colorspanel_enableMore !== false;
				let	total = colors.length + (moreColorsEnabled ? 2 : 1);

				let clickFn = CKEDITOR.tools.addFunction(function applyColorStyle(color, type) {
					editor.focus();
					editor.fire('saveSnapshot');

					const applyColor = function(color) {
						let currentColor = colors.find((current) => current.id === color);
						let colorStyle = config['colorspanel_' + type + 'Style'];

						colors.forEach((current) => {
							let colorStyleToRemove = Object.assign({}, config['colorspanel_' + type + 'Style']);

							colorStyleToRemove.attributes.class = current.id;
							editor.removeStyle(new CKEDITOR.style(colorStyleToRemove));
						});

						if (currentColor) {
							colorStyle.attributes.class = currentColor.id;

							colorStyle.childRule = type == 'back' ?
							function(element) {
								return isUnstylable(element);
							} : function(element) {
								return !(element.is('a') || element.getElementsByTag('a').count()) || isUnstylable(element);
							};
						}

						editor.focus();
						if (currentColor) {
							editor.applyStyle(new CKEDITOR.style(colorStyle, {color: color}));
						}
						editor.fire('saveSnapshot');
					};

					if (color == '?') {
						editor.getColorFromDialog(function(color) {
							if (color) {
								return applyColor(color);
							}
						});
					} else {
						return applyColor(color);
					}
				});

				let selection = editor.getSelection();
				let	block = selection && selection.getStartElement();
				let	path = editor.elementPath(block);
				let	automaticColor = '#ffffff';

				if (path) {
					block = path.block || path.blockLimit || editor.document.getBody();

					automaticColor = block && block.getComputedStyle('color') || 'transparent';
				}

				if (config.colorspanel_enableAutomatic !== false) {
					output.push('<a class="cke_colorauto" _cke_focus=1 hidefocus=true' +
						' title="', lang.auto, '"' +
						' onclick="CKEDITOR.tools.callFunction(', clickFn, ',null,\'', type, '\');return false;"' +
						' href="javascript:void(\'', lang.auto, '\')"' +
						' role="option" aria-posinset="1" aria-setsize="', total, '">' +
							'<table role="presentation" cellspacing=0 cellpadding=0 width="100%">' +
								'<tr>' +
									'<td colspan="' + colorsPerRow + '" align="center"><span style="border:1px solid; border-radius: 100%; background-color:', automaticColor, '" class="cke_colorbox" id="', colorBoxId, '"></span>', lang.auto, '</td>' +
								'</tr>' +
							'</table>' +
						'</a>');
				}
				output.push('<table role="presentation" cellspacing=0 cellpadding=0 width="100%">');

				for (let i = 0; i < colors.length; i++) {
					if ((i % colorsPerRow) === 0) {
						output.push('</tr><tr>');
					}

					let	colorName = colors[i].id;
					let	colorCode = colors[i].color;
                    let colorLabel = editor.lang.colorspanel.colors[colorCode] || colorCode;

					output.push('<td>' +
						'<a class="cke_colorbox" _cke_focus=1 hidefocus=true' +
							' title="', colorLabel, '"' +
							' onclick="CKEDITOR.tools.callFunction(', clickFn, ',\'', colorName, '\',\'', type, '\'); return false;"' +
							' href="javascript:void(\'', colorLabel, '\')"' +
							' data-value="' + colorCode + '"' +
							' role="option" aria-posinset="', (i + 2), '" aria-setsize="', total, '">' +
							'<span class="cke_colorbox" style="border:1px solid; border-radius: 100%; background-color:', colorCode, '"></span>' +
						'</a>' +
						'</td>');
				}

				output.push('</table>');

				return output.join('');
			};

			const isUnstylable = function(ele) {
				return (ele.getAttribute('contentEditable') == 'false') || ele.getAttribute('data-nostyle');
			};

			const selectColor = function(block, color) {
				let items = block._.getItems();

				for (let i = 0; i < items.count(); i++) {
					let item = items.getItem(i);

					item.removeAttribute('aria-selected');

					if (color && color == normalizeColor(item.getAttribute('data-value'))) {
						item.setAttribute('aria-selected', true);
					}
				}
			};

			const normalizeColor = function(color) {
				return CKEDITOR.tools.convertRgbToHex(color || '').replace(/#/, '').toLowerCase();
			};
		},
	});

	CKEDITOR.config['colorspanel_colors'] = '1ABC9C,2ECC71,3498DB,9B59B6,4E5F70,F1C40F,' +
		'16A085,27AE60,2980B9,8E44AD,2C3E50,F39C12,' +
		'E67E22,E74C3C,ECF0F1,95A5A6,DDD,FFF,' +
		'D35400,C0392B,BDC3C7,7F8C8D,999,000';

	CKEDITOR.config['colorspanel_foreStyle'] = {
		element: 'span',
		styles: {'color': '#(color)'},
		overrides: [{
			element: 'font', attributes: {'color': null},
		}],
	};

	CKEDITOR.config['colorspanel_backStyle'] = {
		element: 'span',
		styles: {'background-color': '#(color)'},
	};
}

require('./langs/fr');
require('./langs/en');
